import {
  Box,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';
import _ from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from '../../../helpers/colors';

const styles = {
  box: {
    width: '100%',
    height: '330px',

    overflowY: 'auto',
    overflowX: 'hidden',
    backgroundColor: 'white',
    borderRadius: '0.8em',
    border: '1px solid #0000001F',
    padding: '1em',
  },
  label: {
    width: '450px',
    backgroundColor: '#fcfcfc',

    fontSize: '11px',

    padding: 1,
    marginBottom: '2em',
    '&.MuiChecked': {
      color: '#7C0E6F',
    },
  },
  subtitle: {
    fontStyle: 'italic',
    fontSize: '0.75em',
    color: colors.grey,
  },
  subText: {
    fontSize: '10px',

    color: '#92929D',
  },
  text: {
    fontSize: '12px',

    color: '#464545',
  },
  labelBox: {
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
  },
  innerCardTitle: {
    color: '#7C0E6F',
    fontWeight: 'bold',
    fontSize: '14px',
  },
  subheader2: {
    color: '#92929D',

    fontSize: '10px',
  },
};

const Reporter = (props) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(undefined);
  
  const handleChange = (e) => {
    setValue(e.target.value);
    props.onSelect(e.target.value);
  };

  return (
    <Card elevation={0}>
      <CardHeader
        title={
          <Typography style={styles.innerCardTitle}>{props.BU}</Typography>
        }
        subheader={
          <Typography style={styles.subheader2}>
            {t('Department All')}
          </Typography>
        }
      />
      <CardContent>
        <Box style={styles.box}>
          <FormControl
            sx={{ width: '100%', padding: 1 }}
            component="fieldset"
            variant="standard"
          >
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={value}
              onChange={handleChange}
            >
              {_.map(props.managers, (data, index) => {
                return (
                  <FormControlLabel
                    style={styles.label}
                    value={data.id}
                    key={data.id}
                    control={
                      <Radio
                        size="small"
                        checked={Number(data.id) === Number(value)}
                        style={{
                          color: '#7C0E6F',
                          '&.Mui-checked': {
                            color: '#7C0E6F',
                          },
                        }}
                      />
                    }
                    label={
                      <Box style={styles.labelBox}>
                        <Typography style={styles.text}>
                          {data.user.name}
                        </Typography>
                        <Typography style={styles.subtitle}>
                          {"id:" + data?.user?.employee?.staff_id}
                        </Typography>
                      </Box>
                    }
                  />
                );
              })}
            </RadioGroup>
          </FormControl>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Reporter;
